import { useState, useEffect, useCallback, useMemo } from 'react';
import React from 'react';
import { getDmImei, getDms, writeRsCmdSettings } from '../../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import Button from "../../../UI/Button/Button";
import Modal from '../../../UI/Modal/Modal'
import { preparePchTimeAndSpeed, checkConnectionSlave } from '../../../Utils/Functions';
import { checkDeviceLink } from '../../../Utils/DateFormatter';
import '../RsConfig.css'

export default React.memo (function RsPassport() {
    const parameter = useSelector((state) => state.dmimei.data[0]);
    const dispatch = useDispatch();
    const iduser = localStorage.getItem('iduser');
    const isConnectionLost = checkConnectionSlave(parameter);
    const browserTime = new Date();
    const islink = checkDeviceLink(parameter?.param_last_date, browserTime);
    // Централизованное состояние для всех модальных окон
    const [modalState, setModalState] = useState({
        isOpen: false,
        modalType: null, // 'name', 'type', или 'param'
        inputValue: '',
        hasError: false,
        currentParam: null,
        currentIndex: null,
        isLoading: false
    });

    // Мемоизированные данные     
    const passportParam = useMemo(() => { 
        const pchData = preparePchTimeAndSpeed(parameter?.typeRsDevice_name,
                                    parameter?.param2,
                                    parameter?.param3,
                                    parameter?.param4,
                                    parameter?.param5);  
       // Если есть данные PCH, используем их
        if (pchData) {
            return [
                pchData.highSpeed,
                pchData.lowSpeed,
                pchData.timeAcceleration,
                pchData.timeDeceleration];
         };   
            // Если нет данных PCH, возвращаем ...
    return ['...','...','...','...'];

}, [parameter?.param2, parameter?.param3,
    parameter?.param4, parameter?.param5,
    parameter?.typeRsDevice_name]);

    const nameParam = useMemo(() => [
        "Верхняя скорость, Гц",
        "Нижняя скорость, Гц",
        "Время разгона, с",
        "Время торможения, с"
    ], []);

    // Общие обработчики модального окна
    const handleModalOpen = useCallback((modalType, currentParam = null, currentIndex = null) => {
        let initialValue = '';
        if (modalType === 'param' && currentIndex !== null) initialValue = passportParam[currentIndex];
        
        setModalState({
            isOpen: true,
            modalType,
            inputValue: initialValue,
            hasError: false,
            currentParam,
            currentIndex,
            isLoading: false
        });
    }, [passportParam]);

    const handleModalClose = useCallback(() => {
        setModalState(prev => ({ ...prev, isOpen: false }));
    }, []);

    const handleInputChange = useCallback((e) => {
        setModalState(prev => ({ ...prev, inputValue: e.target.value }));
    }, []);

    // Унифицированная функция сохранения
    const handleSave = useCallback(async () => {
        const { modalType, inputValue, currentIndex } = modalState;
        
        if (!inputValue || inputValue==="..." || inputValue===' ') {
            setModalState(prev => ({ ...prev, hasError: true }));
            return;
        }

        try {
            setModalState(prev => ({ ...prev, isLoading: true }));
            
            let num, value;
            switch(modalType) {
                case 'param':
                    num = 21 + currentIndex;
                        if ((parameter?.typeRsDevice_name=== 'PCH_Instart') ||
                         (parameter?.typeRsDevice_name=== 'PCH_ESQ')) 
                        {
                            if((currentIndex===0)|| (currentIndex===1)) {
                            value=(Math.round(inputValue * 100) / 100)*100;}
                        
                            if((currentIndex===2)|| (currentIndex===3)) {
                            value=(Math.round(inputValue * 10) / 10)*10;}
                        }
                        if (parameter?.typeRsDevice_name=== 'PCH_ATV') {
                            value=(Math.round(inputValue * 10) / 10)*10;}
                    break;
                default:
                    return;
            }

            await dispatch(writeRsCmdSettings(parameter?.imei, value, num));
            await dispatch(getDmImei(parameter?.imei));
            if (modalType === 'param') {
                await dispatch(getDms(iduser));
            }

            handleModalClose();
        } catch (error) {
            console.error("Ошибка при сохранении или обновлении данных: ", error);
        } finally {
            setModalState(prev => ({ ...prev, isLoading: false }));
        }
    }, [modalState, parameter?.imei, passportParam, dispatch, handleModalClose, iduser]);

    // Оптимизированный компонент параметров ПЧ
    const ParametrPch = useCallback(() => (
        nameParam.map((text, index) => (
            <div className='ParamInput' key={index}>
                <label>{text}</label>
                <Button onClick={() => handleModalOpen('param', text, index)}>
                    <span className='buttonInput'>{(islink && !isConnectionLost) ? passportParam[index]: '...'}</span>
                </Button>
            </div>
        ))
    ), [nameParam, passportParam, handleModalOpen]);

    return (
        <> 
            <ParametrPch />
            {/* Единое модальное окно */}
            <Modal open={modalState.isOpen}>
                <div className='modalHeader'>
                    <h3>Введите новое значение</h3>
                    <svg onClick={handleModalClose} height="30" viewBox="0 0 200 200" width="30">    
                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                    </svg> 
                </div>
                <div className='modalInfo'> 
                    <label className='labelInfo'>
                        {modalState.currentParam}
                    </label>
                    <h4 className='labelInfoQuet'>
                        {modalState.hasError 
                            ? "Передумали?" 
                            : `Желаете установить ${modalState.inputValue}?`}
                    </h4>
                </div>
                <div className='contentControl'>
                    <input 
                        type='number'
                        className='input' 
                        value={modalState.inputValue.trim()} 
                        onChange={handleInputChange}
                        style={{ border: modalState.hasError ? '1px solid red' : null }} 
                    />
                    <div className='modalButton'>
                        <Button onClick={handleModalClose} color="#d2e9d2">Отмена</Button>
                        <Button onClick={handleSave} color="#4bdd4b">Сохранить</Button>
                    </div>
                </div>
            </Modal>
        </>
    );
});